import locale from "localization/en";

export const promoSumaryColumn = [
  { key: "promoName", text: locale.promoName },
  { key: "transactionCount", text: locale.transactionCount },
  { key: "volume", text: locale.volumeSold },
  { key: "qty", text: locale.qtySold },
  { key: "createdAt", text: locale.createdAt },
  { key: "actions", text: "" },
];
